import { getSubdomain } from "utils";

export const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT_URL;

export const API_CENTRAL_URL = import.meta.env.VITE_CENTRAL_API_ENDPOINT_URL;

// MapLibre RTL text plugin (served locally from public/ — no external CDN).
export const MAPLIBRE_RTL_PLUGIN_URL = "/vendor/mapbox-gl-rtl-text.min.js";

// SPL map style, tiles, reverse-geocode and address search all go through the
// amer-laravel backend proxy (maps/*) — no SPL API key or endpoint (dev or
// production) lives in the frontend. The style URL is built by
// getSplMapStyleUrl() in services/spl.js.

export const MOYASAR_PUBLISHABLE_KEY = import.meta.env
  .VITE_MOYASAR_PUBLISHABLE_KEY;
export const MOYASAR_TOKENS_URL = "https://api.moyasar.com/v1/tokens";
export const CORPORATE_WEBSITE_URL = (
  import.meta.env.VITE_CORPORATE_WEBSITE_URL || ""
).replace("TENANT_SLUG", getSubdomain());

// The tenant's corporate website, optionally at a language and a path under it:
// getCorporateWebsiteUrl("ar") → https://<tenant>.corporate…/ar
export const getCorporateWebsiteUrl = (lang, path = "") =>
  [CORPORATE_WEBSITE_URL.replace(/\/+$/, ""), lang, path.replace(/^\/+/, "")]
    .filter(Boolean)
    .join("/");

// The website's host alone, for display (no protocol, no path).
export const getCorporateWebsiteHost = () =>
  CORPORATE_WEBSITE_URL.replace(/^https?:\/\//, "").replace(/\/.*$/, "");

export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

export const MAX_UPLOAD_FILE_SIZE_MB =
  Number(import.meta.env.VITE_MAX_UPLOAD_FILE_SIZE_MB) || 5;
